const baseurl = "https://dlapi.wipenex.com/api";

// const baseurl = "https://localhost:44303/api";

export const baseUIurl = "https://localhost:1234";
export default baseurl;

export let logo ="https://retaildukan.wipenex.com/public/images/1743232781.png";
